import moment from 'moment'
import { _, React, withStyles, StyledProps } from '@api'
import { Theme, Typography } from '@material-ui/core'
import { TextInput } from 'centric-ui-components'

const styles = (theme: Theme) => ({
  inputDisabled: {
    color: 'rgba(27, 27, 27, 0.87)',
    fontSize: 14,
    '&:before': {
      borderBottom: '0 !important'
    }
  }
})

interface MyProps extends StyledProps {
  label?: string
  value?: string
}

@(withStyles as any)(styles)
export class DateField extends React.Component<MyProps> {
  render() {
    const {props: {classes, label, value}} = this

    return <TextInput
      disabled
      label={label}
      value={value ? moment(value).format('MM/DD/YYYY') : '--'}
      InputProps={{
        classes: {disabled: classes.inputDisabled}
      }}
    />
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/DateField.tsx